export const ERROR_MESSAGE = 'Oops! Something went wrong. Please try again later.';

export const GETALL_REQ_WS = 'GETALL_REQ_WS';
export const GETALL_SUCCESS_WS = 'GETALL_SUCCESS_WS';
export const GETALL_FAILURE_WS = 'GETALL_FAILURE_WS';
export const SET_WORKING_WS = 'SET_WORKING_WS';


export const SET_SELECTED_WS_REQ = 'SET_SELECTED_WS_REQ';
export const SET_SELECTED_WS_SUCCESS = 'SET_SELECTED_WS_SUCCESS';